import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, ArrowRight } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
export function ServiceAreasPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const areas = [{
    county: 'St. Clair County',
    type: 'Primary',
    color: 'bg-brand-blue',
    cities: ['Port Huron', 'Marysville', 'St. Clair', 'Marine City', 'New Baltimore', 'Algonac', 'Ira Township', 'China Township', 'Casco Township']
  }, {
    county: 'Macomb County',
    type: 'Secondary',
    color: 'bg-brand-gray-dark',
    cities: ['Harrison Township', 'Clinton Township', 'Chesterfield', 'Macomb Township', 'Sterling Heights', 'Warren', 'Roseville', 'Utica', 'New Baltimore', 'St. Clair Shores']
  }, {
    county: 'Oakland County',
    type: 'Tertiary',
    color: 'bg-brand-gray',
    cities: ['Troy', 'Rochester Hills', 'Auburn Hills', 'Pontiac', 'Clarkston', 'Lake Orion', 'Oxford']
  }];
  return <div className="w-full bg-white" data-id="element-855">
      {/* Hero */}
      <section className="relative min-h-[40vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-856">
        <div className="absolute inset-0 z-0" data-id="element-857">
          <img src="https://images.unsplash.com/photo-1598228723793-52759bba239c?w=1920&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-858" />
          <div className="absolute inset-0 bg-brand-blue/15 z-[1]" data-id="element-859"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-black/30 z-[2]" data-id="element-860"></div>
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-861">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-862">
            <h1 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-863">
              Proudly Serving{' '}
              <span className="text-brand-blue" data-id="element-864">Southeast Michigan</span>
            </h1>
            <p className="font-body text-xl text-gray-200 max-w-2xl leading-relaxed" data-id="element-865">
              Based in Harrison Township, Moceri Residential Services provides
              expert exterior contracting across three counties and 25+
              communities.
            </p>
          </motion.div>
        </div>
      </section>

      {/* County Sections */}
      <section className="py-20" data-id="element-866">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-867">
          <div className="space-y-16" data-id="element-868">
            {areas.map((area, areaIndex) => <motion.div key={areaIndex} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} data-id="element-869">
                <div className="flex items-center gap-4 mb-8" data-id="element-870">
                  <div className={`w-3 h-12 ${area.color} rounded-full`} data-id="element-871"></div>
                  <div data-id="element-872">
                    <h2 className="font-heading font-bold text-3xl text-brand-gray-dark" data-id="element-873">
                      {area.county}
                    </h2>
                    <span className="font-body text-sm text-brand-gray font-semibold uppercase tracking-wider" data-id="element-874">
                      {area.type} Service Area
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-875">
                  {area.cities.map((city, cityIndex) => <Link key={cityIndex} to={`/area/${city.toLowerCase().replace(/\s+/g, '-')}`} className="bg-gray-50 hover:bg-brand-blue hover:text-white text-brand-gray-dark p-5 rounded-xl border border-gray-100 hover:border-brand-blue transition-all duration-300 group flex items-center justify-between" data-id="element-876">
                      <div className="flex items-center gap-3" data-id="element-877">
                        <MapPin size={18} className="text-brand-blue group-hover:text-white transition-colors shrink-0" data-id="element-878" />
                        <span className="font-body font-semibold" data-id="element-879">{city}</span>
                      </div>
                      <ArrowRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-880" />
                    </Link>)}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <ContactCTA data-id="element-881" />
    </div>;
}